import React from 'react';
import Api from '../../api/api';
import { ModalAlert } from '../popups/modal-parts';
import '../popups/modal.scss';

// success or error message above a form, scrolled into view whenever it changes
export default class Notice extends React.Component {
  constructor(props){
    super(props);
    this.noticeRef = React.createRef();
  }

  componentDidMount(){
    this.shownText = this.noticeRef.current.textContent;
    Api.scrollCentre('#notice');
  }

  // the parent re-renders on every keystroke, so only scroll when the message changes
  componentDidUpdate(){
    const text = this.noticeRef.current.textContent;
    if (text === this.shownText) return;
    this.shownText = text;
    Api.scrollCentre('#notice');
  }

  render(){
    return (
      <div id="notice" ref={this.noticeRef} className="form-notice">
        <ModalAlert type={this.props.type}>
          {this.props.children}
        </ModalAlert>
      </div>
    )
  }
}
